module.exports = __webpack_public_path__ + "img/tp-card-blank.58e5490b.png";